import API from '../API/newIndex';

/**
 * Fetch blog categories list with pagination and search
 */
export const fetchBlogCategories = async ({
  page = 1,
  limit = 10,
  searchkey = '',
} = {}) => {
  try {
    const trimmedSearch = (searchkey || '').trim();
    const searchParam = trimmedSearch.length >= 3 ? encodeURIComponent(trimmedSearch) : '';
    const url = `/admin/blogcategory/GetBlogCategoriesWithParent?page=${page}&limit=${limit}&searchkey=${searchParam}`;

    const res = await API({
      url,
      method: 'get',
    });
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Fetch parent categories for dropdowns/selects
 */
export const fetchParentBlogCategories = async (searchkey = '') => {
  try {
    const trimmedSearch = (searchkey || '').trim();
    const searchParam = trimmedSearch.length > 0 ? `&searchkey=${encodeURIComponent(trimmedSearch)}` : '';
    const url = `/admin/blogcategory/GetBlogCategoriesWithParent?default=true${searchParam}`;

    const res = await API({
      url,
      method: 'get',
    });
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Fetch a single blog category by ID
 */
export const getParticularBlogCategory = async (id) => {
  try {
    const res = await API({
      url: `/admin/blogcategory/getBlogCategory/${id}`,
      method: 'get',
    });
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Add a new blog category
 */
export const addBlogCategory = async (payload) => {
  try {
    const res = await API({
      url: '/admin/blogcategory/addBlogCategory',
      method: 'post',
      data: payload,
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Update an existing blog category by ID
 */
export const updateBlogCategory = async (id, payload) => {
  try {
    const res = await API({
      url: `/admin/blogcategory/updateBlogCategory/${id}`,
      method: 'put',
      data: payload,
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Delete blog category(ies) by ID array
 */
export const deleteBlogCategories = async (ids) => {
  try {
    const res = await API({
      url: '/admin/blogcategory/deleteBlogCategory',
      method: 'post',
      data: { id: ids },
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};
